import React, { Component } from 'react'
import StipulationMappingForm, {
  FormProps as StipulationMappingFormProps,
} from './form'
import { History } from 'history'
import { StipulationMapping } from '../tasks/types'
import { connect } from 'react-redux'
import { fetchMapping, updateMapping } from './mappingActions'
import {
  selectMapping,
  selectMappingMeta,
} from '../../reducers/stipulationMappings'
import { withRouter } from 'react-router-dom'

export type Callback<T = void> = (...args: any) => T
export interface Match<T> {
  params: T
}

export interface ParamsID {
  id: string
}

export interface Props {
  fetchMapping: Callback
  history?: History
  mapping: StipulationMapping
  match: Match<ParamsID>
  updateMapping: Callback<Promise<any>>
}

export class StipulationMappingEdit extends Component<Props> {
  componentDidMount() {
    const { fetchMapping, mapping, match } = this.props
    const mappingId = match && match.params && match.params.id
    if (mappingId && !mapping.id) {
      fetchMapping(mappingId)
    }
  }

  handleSubmit = (values: StipulationMappingFormProps) => {
    const { history, mapping, updateMapping } = this.props
    const updated = (({ adminVerificationType, mode, title, description }) => ({
      adminVerificationType,
      mode,
      title,
      description,
    }))(values)
    return updateMapping({ ...updated, id: mapping.id }).then(() => {
      history && history.goBack()
    })
  }

  render() {
    const { mapping } = this.props

    if (!mapping) {
      return null
    }

    return (
      <div className="stipulation-mapping">
        <div className="stipulation-mapping__body">
          <h2>Edit Stipulation Mapping</h2>
          <input
            className="form__control"
            type="text"
            disabled={true}
            value={mapping.identifier}
          />
          <StipulationMappingForm
            mapping={mapping}
            initialValues={mapping}
            history={this.props.history}
            onSubmit={this.handleSubmit}
          />
        </div>
      </div>
    )
  }
}

export const mapStateToProps = (state, { match }) => {
  return {
    mapping: selectMapping(state.stipulationMappings, match.params.id),
    meta: selectMappingMeta(state.stipulationMappings),
  }
}

export default withRouter(
  connect(mapStateToProps, {
    fetchMapping,
    updateMapping,
  })(StipulationMappingEdit)
)
